import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";

export default function useMobile() {
  const isMobileByMediaQuery = useMediaQuery('(max-width:768px)');
  const isMobileByUserAgent = navigator && navigator.userAgent && /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) // /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  const isMobile = isMobileByMediaQuery || isMobileByUserAgent

  return {
    isMobileByMediaQuery,
    isMobileByUserAgent,
    isMobile,
  }
}

